import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskSsn'
})
export class MaskSsnPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    if (value.length === 4) {
      return `XXX-XX-${value}`;
    } else if (value.length === 9) {
      return `${value.substring(0, 3)}-${value.substring(3, 5)}-${value.substring(5)}`;
    } else {
      return value;
    }
  }
}